import { render, staticRenderFns } from "./PresentUserInfo.vue?vue&type=template&id=d0a6a802"
import script from "./PresentUserInfo.vue?vue&type=script&lang=js"
export * from "./PresentUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports